var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDeliveryTruck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.632,
    height: 29.176,
    viewBox: "0 0 41.632 29.176",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#69b64a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -67.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.219,80.007,37.384,78.78,34.976,74.1a3.791,3.791,0,0,0-3.411-2.073H27.42V70.852A3.824,3.824,0,0,0,23.609,67H3.793A3.814,3.814,0,0,0,0,70.852V88.791a2.337,2.337,0,0,0,2.305,2.37h.53c0,.093-.009.13-.009.186a4.815,4.815,0,1,0,9.629.037v-.046a1.446,1.446,0,0,0-.009-.186H28.461v.186a4.815,4.815,0,0,0,9.629.037v-.232h1.2A2.344,2.344,0,0,0,41.631,88.8V82.164A2.331,2.331,0,0,0,40.219,80.007ZM7.65,94.33a2.956,2.956,0,1,1,2.956-2.956A2.951,2.951,0,0,1,7.65,94.33Zm17.911-5.01H12.009a4.808,4.808,0,0,0-8.718,0H2.343a.481.481,0,0,1-.483-.511V84.023h23.7Zm0-18.459v11.3H1.86v-11.3a1.956,1.956,0,0,1,1.933-1.989H23.609a1.969,1.969,0,0,1,1.952,1.98Zm1.859,3.03h4.145a1.962,1.962,0,0,1,1.766,1.05l1.859,3.6H27.42ZM33.285,94.33a2.956,2.956,0,1,1,2.956-2.956A2.951,2.951,0,0,1,33.285,94.33Zm6.5-5.521a.481.481,0,0,1-.483.511H37.644a4.811,4.811,0,0,0-8.718,0H27.42V80.4h9.109l2.956,1.3a.547.547,0,0,1,.3.5Z",
    transform: "translate(0 -67.004)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeliveryTruck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deliveryTruck.f28f35f2.svg";
export { ForwardRef as ReactComponent };